// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';

// project imports
import Profile from './Profile';
import MobileSection from './MobileSection';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  return (
    <>
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
